// src/services/api.ts - UPDATED WITH MULTI-CURRENCY FIELDS ONLY
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5248/api';

// ==================== AFFILIATE TAG TYPES ====================
export type AffiliateTagPool = 'general' | 'bringgoship' | 'autoorder';

export interface AffiliateTag {
  id: string;
  tagCode: string;
  description: string | null;
  isDefault: boolean;
  isActive: boolean;
  userCount: number;
  createdAtUtc: string;
  updatedAtUtc: string;
  /** Rotasyon havuzu — rotasyon yalnız aynı havuzun tagları arasında döner */
  pool: AffiliateTagPool;
}

export interface AffiliateTagListResponse {
  tags: AffiliateTag[];
  total: number;
}

export interface CreateAffiliateTagRequest {
  tagCode: string;
  description?: string;
  isActive?: boolean;
  pool?: AffiliateTagPool;
}

export interface UpdateAffiliateTagRequest {
  tagCode: string;
  description?: string;
  isDefault?: boolean;
  isActive: boolean;
  pool?: AffiliateTagPool;
}

export interface BulkAssignTagRequest {
  userIds: string[];
  tagId: string;
}

export interface BulkAssignTagResponse {
  message: string;
  updatedCount: number;
  failedUsers: string[];
}

export interface AffiliateTagDropdown {
  id: string;
  tagCode: string;
  isDefault: boolean;
}

export interface TagUsersResponse {
  tagCode: string;
  userCount: number;
  users: Array<{
    id: string;
    email: string;
    fullName: string;
    isActive: boolean;
    createdAtUtc: string;
  }>;
}

export interface LoginRequest {
  email: string;
  password: string;
}
export interface AdminDashboardStats {
  users: {
    total: number;
    active: number;
    inactive: number;
    newLast30Days: number;
  };
  orders: {
    total: number;
    delivered: number;
    pending: number;
  };
  earnings: {                      // ← BUNU EKLE!
    totalOrderAmount: number;
    totalEarnings: number;
    monthlyEarnings: number;
    averageOrderValue: number;
  };
  paymentMethods: {
    total: number;
  };
  range?: { start: string; end: string };
  chartData?: AdminChartPoint[];
}

export interface AdminChartPoint {
  name: string;
  orders: number;
  delivered: number;
  amount: number;
  earnings: number;
}

export interface UrlTraceEventRow {
  id: string;
  userId: string;
  email: string;
  flowId?: string | null;
  orderId?: string | null;
  asin?: string | null;
  step?: string | null;
  url?: string | null;
  observedTag?: string | null;
  isForeignTag: boolean;
  expectedTag?: string | null;
  orderAffiliateTag?: string | null;
  commissionRate?: number | null;
  createdAtUtc: string;
}
export interface UrlTraceListResponse {
  page: number;
  pageSize: number;
  total: number;
  results: UrlTraceEventRow[];
}
export interface UrlTraceSummary {
  totalForeign: number;
  usersWithForeign: number;
  byUser: Array<{ userId: string; foreignCount: number; lastForeignAtUtc: string }>;
}

// ==================== SENKRON TURLARI (admin) ====================
// Manuel ve otomatik sipariş güncellemelerinin ne yaptığı. Sayıların kaynağı
// turların kendi kayıtları (SyncRuns) + siparişlerin güncel doğrulama durumu.
export interface AdminSyncTotals {
  runs: number;
  users: number;
  asked: number;      // Amazon'a sorulan sipariş
  updated: number;    // backend'e gönderilip yazılan
  verified: number;   // tur sayesinde doğrulanan — asıl fayda
  finalized: number;  // iptal/iade nedeniyle kapanan
  skipped: number;
  errors: number;
}
export interface AdminSyncSummary {
  days: number;
  auto: AdminSyncTotals;
  manual: AdminSyncTotals;
  outcomes: Array<{ outcome: string; count: number }>;
  versions: Array<{ version: string; count: number }>;
  pending: {
    dueNow: number;               // otomatik turun şu an alacağı sipariş sayısı
    deliveredUnverified: number;  // teslim edilmiş ama doğrulanmamış (eşiği dolmayanlar dahil)
    unreadable: number;           // üst üste okunamayan (hedefte KALIR — çoğunlukla başka alıcı hesabı)
    retryingNow: number;          // birkaç kez okunamadı, henüz eşiğin altında
  };
}
export interface AdminSyncRunRow {
  id: string;
  userId: string;
  email: string;
  type: 'auto' | 'manual' | string;
  startedAtUtc: string;
  finishedAtUtc?: string | null;
  targetCount: number;
  askedCount: number;
  updatedCount: number;
  verifiedCount: number;
  finalizedCount: number;
  skippedCount: number;
  errorCount: number;
  outcome: string;
  note?: string | null;
  extVersion?: string | null;
  /** Turun çalıştığı Amazon alıcı hesabı (eklenti 5.8.0+; eski turlarda null). */
  buyerEmail?: string | null;
}
export interface AdminSyncRunsResponse {
  total: number;
  page: number;
  pageSize: number;
  rows: AdminSyncRunRow[];
}
export interface AdminSyncUserRow {
  userId: string;
  email: string;
  dueNow: number;
  runs: number;
  verified: number;
  lastRunAtUtc?: string | null;
  lastOutcome?: string | null;
  lastAutoSyncAtUtc?: string | null;
}
export interface AdminSyncUsersResponse {
  days: number;
  count: number;
  rows: AdminSyncUserRow[];
}
export interface VerificationExplain {
  orderId: string;
  userId: string;
  status?: string | null;
  orderDateUtc: string;
  updatedAtUtc: string;
  deliveryDateUtc?: string | null;
  thresholdUtc: string;
  thresholdRule: string;
  verified: boolean;
  finalized: boolean;
  excludedFromPayment: boolean;
  needsSync: boolean;
  inAutoScope: boolean;
  state: 'verified' | 'closed' | 'not-delivered' | 'waiting-threshold' | 'needs-update' | string;
  explain: string;
  next: string;
  statusHistory: Array<{ changedAtUtc: string; oldStatus?: string | null; newStatus?: string | null }>;
  lastRuns: Array<{
    type: string; startedAtUtc: string; finishedAtUtc?: string | null; outcome: string;
    targetCount: number; askedCount: number; updatedCount: number; verifiedCount: number; note?: string | null;
  }>;
}

// ==================== STAFF PANELİ (kazanç İÇERMEZ) ====================
export interface StaffCustomer {
  id: string;
  email: string;
  fullName: string;
  phoneNumber?: string | null;
  signupSource?: string | null;
  isActive: boolean;
  createdAtUtc: string;
  status?: string | null;             // sicak | soguk | aktif
  nextCallAtUtc?: string | null;
  lastContactAtUtc?: string | null;
  orderCount: number;                 // sadece adet — tutar yok
  lastOrderDateUtc?: string | null;
  hasPlugin: boolean;
  lastActivityUtc?: string | null;
  referredByName?: string | null;     // bu müşteriyi kim getirdi
}
export interface StaffCustomerList {
  page: number;
  pageSize: number;
  total: number;
  customers: StaffCustomer[];
}
export interface StaffContactLogEntry {
  id: string;
  channel: string;                    // whatsapp | phone | email | note
  note?: string | null;
  staffName?: string | null;
  createdAtUtc: string;
}
export interface StaffCustomerDetail {
  customer: {
    id: string; email: string; fullName: string;
    phoneNumber?: string | null; signupSource?: string | null;
    isActive: boolean; createdAtUtc: string;
  };
  crm: {
    status?: string | null;
    nextCallAtUtc?: string | null;
    nextCallTopic?: string | null;
    lastContactAtUtc?: string | null;
    notes?: string | null;
  };
  referral?: {
    referredBy?: { id: string; fullName: string; email: string } | null;
    referredCount: number;
    referralCode?: string | null;
  };
  activation: {
    orderCount: number;
    lastOrderDateUtc?: string | null;
    hasPlugin: boolean;
    pluginSoftware?: string | null;
    lastActivityUtc?: string | null;
    lastSeenWebAtUtc?: string | null;   // web paneline son görülme
  };
  contactLog: StaffContactLogEntry[];
}
export interface StaffStats {
  totalCustomers: number;
  activeCustomers: number;
  withOrders: number;
  dueToday: number;
  statuses: { hot: number; cold: number; active: number };
}
export interface ApiKeyRow {
  id: string;
  name: string;
  /** Anahtarın ilk karakterleri — tanımak için (tam anahtar asla dönmez) */
  keyPrefix: string;
  userEmail: string;
  scopes?: string | null;
  isActive: boolean;
  rateLimitPerHour: number;
  createdAtUtc: string;
  lastUsedAtUtc?: string | null;
  revokedAtUtc?: string | null;
  note?: string | null;
}

export interface ApiKeyUsageStats {
  ok: boolean;
  days: number;
  total: number;
  /** EN ÖNEMLİ GÖSTERGE: 1-3 = sunucudan geliyor · 50+ = kullanıcılara dağıtılmış */
  distinctIps: number;
  byDay: { date: string; count: number }[];
  byPath: { path: string | null; count: number }[];
  byStatus: { status: number; count: number }[];
  topIps: { ip: string; count: number; last: string }[];
}

export interface ExtensionLogRow {
  id: number;
  userId?: string | null;
  userEmail?: string | null;
  flowId?: string | null;
  software?: string | null;
  level?: string | null;
  action?: string | null;
  message?: string | null;
  dataJson?: string | null;
  url?: string | null;
  extVersion?: string | null;
  tabId?: string | null;
  clientTsUtc?: string | null;
  createdAtUtc: string;
}
export interface ExtensionLogList {
  ok: boolean;
  page: number;
  pageSize: number;
  total: number;
  items: ExtensionLogRow[];
}
export interface StaffCalendarItem {
  id: string;
  fullName: string;
  email: string;
  phoneNumber?: string | null;
  status?: string | null;
  nextCallAtUtc: string;
  topic?: string | null;
}

// ==================== MUHASEBE ====================
// ==================== ASIN WORKER SAĞLIĞI ====================
export interface AsinWorkerHealth {
  /** İş var ama son 30 dakikada tek başarı yok → worker çökmüş sayılır */
  down: boolean;
  lastSuccessUtc: string | null;
  minutesSinceSuccess: number | null;
  pending: number;
  processing: number;
  failed: number;
  oldestPendingUtc: string | null;
}

export interface AccountingPeriodInfo { year: number; month: number; isClosed: boolean; }
export interface AccountingUser {
  userId: string; name: string; email: string;
  gross: number; ratePercent: number; isOverride: boolean; cut: number; keep: number;
  // "Sisteme kazandırdığı" manuel değeri — yalnız iç hesaplar (BringGo, autoorder)
  computedGross?: number;   // siparişlerden hesaplanan
  grossManual?: boolean;    // gross manuel girildi mi
  grossEditable?: boolean;  // bu satırda düzenlenebilir mi
}
export interface AccountingLineItem { id: string; label: string; amount: number; }
export interface AccountingAffiliate {
  userId: string; name: string; email: string; referralCode: string;
  referredEarnings: number;
  /** Ödenecek — müşteri başına 500 USD tavanı uygulanmış (Satış Ortaklığı ekranıyla aynı) */
  commission: number;
  /** Tavansız ham tutar (getirilenlerin kazancı × %20) — bilgi amaçlı */
  rawCommission?: number;
}
export interface AccountingReport {
  year: number; month: number; earningYear: number; earningMonth: number; isClosed: boolean; closedAtUtc?: string | null;
  userShareRatePercent: number; workerRatePercent: number;
  users: AccountingUser[];
  totals: { gross: number; cut: number; keep: number; userCount: number };
  income: AccountingLineItem[]; incomeTotal: number;
  expenseManual: AccountingLineItem[]; userPayoutExpense: number;
  affiliates: AccountingAffiliate[]; affiliateReferredTotal: number; affiliatePayout: number; expenseTotal: number;
  net: number; worker: number; final: number;
  // DEVİR — nakit esaslı düzeltme: gider gerçekten ödendiği ayda yazılır
  // (asgari ödeme tutarının altında kalıp ertelenen dönemler; bkz. Services/PayoutCarryOver.cs)
  carryIn?: AccountingCarryItem[];   // önceki dönemlerden bu aya taşınıp ödenenler
  carryInTotal?: number;
  carryOut?: AccountingCarryItem[];  // bu aydan sonraki aya ertelenenler (bu ay ödenmedi)
  carryOutTotal?: number;
}

export interface AccountingCarryItem {
  userId: string;
  name: string;
  email: string;
  /** Yalnızca carryIn'de dolu — tutarın geldiği kaynak dönem */
  fromYear?: number;
  fromMonth?: number;
  fromPeriodName?: string;
  gross: number;
  cut: number;
}

export interface AdminUser {
  id: string;
  email: string;
  fullName: string;
  phoneNumber: string | null;
  role: string;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string;
  lastOrderUpdateAt?: string | null;  // ✅ YENİ
  signupSource?: string | null;       // reklam/kaynak takibi (?src=)
  lastAutoSyncAtUtc?: string | null;  // ZAMANLAYICI damgası — gerçek son çalışma değil (bkz. lastAutoRunAtUtc)
  syncRequestedAtUtc?: string | null; // admin senkron isteği beklemede (null = yok)
  lastManualSyncAtUtc?: string | null; // son MANUEL tur (SyncRuns'tan)
  lastAutoRunAtUtc?: string | null;    // son OTOMATİK tur (SyncRuns'tan)
}

export interface AdminUsersListResponse {
  page: number;
  pageSize: number;
  total: number;
  users: AdminUser[];
}

export interface AdminUserDetails {
  user: AdminUser;
  stats: {
    totalOrders: number;
    deliveredOrders: number;
    pendingOrders: number;
    totalEarnings: number; // BU SATIRI EKLEYİN
  };
  paymentMethods: Array<{
    id: string;
    accountOwnerType: string;
    currency: string;
    paymentProvider: string;
    payoutMethod: string;
    accountHolderName: string;
    routingNumber?: string;
    accountNumber?: string;
    bankAccountType?: string;
    iban?: string;
    accountIdentifier?: string;
    isPrimary: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
  pluginSettings: {
    software: string;
    cashbackPercentage: number;
    buyerEmail: string | null;
    updatedAtUtc: string;
  } | null;
}

export interface AdminOrder {
  id: string;
  orderId: string;
  orderDateUtc: string | null;
  total: number | null;
  status: string | null;
  createdAtUtc: string;
  /** Siparişi veren Amazon alıcı hesabı (eklenti 5.7.1+; eski kayıtlarda null). */
  buyerEmail: string | null;
  user: {
    id: string;
    email: string;
    fullName: string;
  };
  itemCount: number;
}

export interface AdminOrdersListResponse {
  page: number;
  pageSize: number;
  total: number;
  orders: AdminOrder[];
}

export interface ToggleUserActiveResponse {
  message: string;
  isActive: boolean;
}
export interface RegisterRequest {
  email: string;
  fullName: string;
  password: string;
  phoneNumber: string;
  organizationCode?: string;
  signupSource?: string;
}

export interface AuthResponse {
  accessToken: string;
  expiresAtUtc: string;
  userId: string;
  email: string;
  fullName: string;
  role: string;
  organizationCode?: string;
  organizationName?: string;
  affiliateTag?: string;
  hasAcceptedTerms: boolean;    // ← YENİ ALAN
}

export interface PluginSettings {
  id: string;
  software: string;
  cashbackPercentage: number;
  usesEasyDepo: boolean;
  usesSellerRunningDepo: boolean;
  usesSellerFlashDepo: boolean;
  buyerEmail: string | null;
  /** Gizlilik modu: none | extension | panel | both */
  privacyMode: PrivacyMode;
  /** PIN tanımlı mı (hash'in kendisi asla gelmez) */
  hasPrivacyPin: boolean;
  updatedAtUtc: string;
}

export type PrivacyMode = 'none' | 'extension' | 'panel' | 'both';

export interface SavePrivacyRequest {
  privacyMode: PrivacyMode;
  /** Yeni PIN (4-6 rakam); boşsa mevcut korunur */
  newPin?: string;
  /** PIN tanımlıysa değişiklik için zorunlu */
  currentPin?: string;
  /** PIN korumasını kaldır (currentPin gerekir) */
  removePin?: boolean;
}

export interface SavePluginSettingsRequest {
  software: string;
  cashbackPercentage: number;
  usesEasyDepo: boolean;
  usesSellerRunningDepo: boolean;
  usesSellerFlashDepo: boolean;
  buyerEmail?: string | null;
}
export interface User {
  id: string;
  email: string;
  fullName: string;
  role: string;
  isActive: boolean;
  createdAtUtc: string;
}
// ==================== ORGANIZATION TYPES (YENİ) ====================
export interface Organization {
  id: string;
  name: string;
  code: string;
  description?: string;
  isActive: boolean;
  userCount: number;
  createdAt: string;
}

export interface CreateOrganizationRequest {
  name: string;
  description?: string;
  customCode?: string;
}

export interface UpdateOrganizationRequest {
  name: string;
  description?: string;
  isActive: boolean;
}
// YENİ INTERFACE - Organization Users için
export interface OrganizationUser {
  id: string;
  email: string;
  fullName: string;
  phoneNumber: string | null;
  isActive: boolean;
  createdAtUtc: string;
}

export interface OrganizationValidation {
  isValid: boolean;
  organizationName?: string;
  organizationId?: string;
}

export interface GenerateCodeRequest {
  organizationName: string;
  customCode?: string;
}

export interface GenerateCodeResponse {
  code: string;
}
// Profile Management Interfaces
export interface UserProfile {
  id: string;
  email: string;
  fullName: string;
  phoneNumber: string;
  role: string;
  isActive: boolean;
  createdAtUtc: string;
  organizationName?: string;
  organizationCode?: string;
  stats: {
    totalOrders: number;
    deliveredOrders: number;
    totalEarnings: number;
    bonusLevel: number;
    memberSince: string;
  };
}

export interface UpdateProfileRequest {
  fullName: string;
  phoneNumber: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ScrapeOrderItem {
  title: string;
  asin: string | null;
  link: string | null;
  image: string | null;
  price: number | null;
  quantity: number | null;
  category: string;
  /** Amazon'un ödediği TAM oran (%) — sunucudan gelir */
  commissionRate?: number;
  /** Kullanıcı payı oranı (%) — sunucuda hesaplanır */
  userRate?: number;
  /** Kullanıcı payı tutarı — sunucuda hesaplanır */
  userEarnings?: number;
}

export interface ScrapeOrder {
  id: string;
  orderId: string;
  orderDateUtc: string | null;
  total: number | null;
  status: string | null;
  itemCount: number;
  createdAtUtc: string;
  updatedAtUtc: string;
  items?: ScrapeOrderItem[];
  /** Siparişi veren Amazon alıcı hesabı (null = eski kayıt / okunamadı) */
  buyerEmail?: string | null;
}

export interface OrdersListResponse {
  page: number;
  pageSize: number;
  total: number;
  results: ScrapeOrder[];
}

export interface OrderDetailItem {
  title: string;
  asin: string;
  link: string;
  image: string;
  category: string;
  price: number;
  quantity: number;
}

export interface OrderDetailResponse {
  internalOrderId: string;
  externalOrderId: string;
  itemCount: number;
  items: OrderDetailItem[];
}

// Dashboard için yeni interface'ler
export interface DashboardStats {
  totalOrders: number;
  deliveredOrders: number;
  pendingOrders: number;
  inTransitOrders: number;
  cancelledOrders: number;
  totalEarnings: number;
  totalOrderAmount: number;
  monthlyEarnings: number;
  bonusLevel: number;
}

export interface ChartDataPoint {
  name: string;
  siparisler: number;
  kazanc: number;
  bonus: number;
}

export interface PieDataPoint {
  name: string;
  value: number;
  color: string;
}

export interface RecentOrder {
  id: string;
  product: string;
  image?: string | null;
  date: string;
  status: string;
  bonus: number;
  amount: number;
}

// ============= GÜNCELLENEN PAYMENT METHOD INTERFACE =============
export interface PaymentMethod {
  id: string;
  userId: string;
  
  // YENİ ALANLAR
  accountOwnerType: string; // "Bireysel" | "Kurumsal"
  currency: string;         // "USD" | "TRY"
  paymentProvider: string;  // "Wise"
  payoutMethod: string;     // "ACH" | "IBAN"
  
  accountHolderName: string;
  
  // ACH alanları (USD için)
  routingNumber?: string;
  accountNumber?: string;
  bankAccountType?: string; // "Checking" | "Savings"
  
  // IBAN alanı (TRY için)
  iban?: string;

  // Sağlayıcıya özel tek alan (Cenoa=telefon, Wise=tag, Payoneer=mail, WorldFirst=account id)
  accountIdentifier?: string;

  // YENİ
  isPrimary: boolean;
  createdAt: string;
  updatedAt: string;
}

// ============= GÜNCELLENEN REQUEST INTERFACE'LERİ =============
export interface AddPaymentMethodRequest {
  accountOwnerType: string;
  currency: string;
  paymentProvider: string;
  payoutMethod: string;
  accountHolderName: string;
  routingNumber?: string | null;
  accountNumber?: string | null;
  bankAccountType?: string | null;
  iban?: string | null;
  accountIdentifier?: string | null;
  setAsPrimary: boolean;
}

export interface UpdatePaymentMethodRequest {
  accountOwnerType: string;
  currency: string;
  paymentProvider: string;
  payoutMethod: string;
  accountHolderName: string;
  routingNumber?: string | null;
  accountNumber?: string | null;
  bankAccountType?: string | null;
  iban?: string | null;
  accountIdentifier?: string | null;
  setAsPrimary: boolean;
}

export interface DashboardStatsResponse {
  stats: DashboardStats;
  chartData: ChartDataPoint[];
  pieData: PieDataPoint[];
  recentOrders: RecentOrder[];
  lastOrderUpdateAt?: string | null;  // ✅ YENİ: ISO tarih stringi (UTC), hiç güncellenmemişse null
}

class ApiService {
  private baseUrl = API_BASE_URL;

  private getHeaders(includeAuth: boolean = false): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (includeAuth) {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return headers;
  }
 // Dashboard Stats — opsiyonel tarih aralığı (varsayılan: son 30 gün, backend belirler)
/** ASIN worker (komisyon oranı çeken servis) sağlığı — admin panel uyarı şeridi. */
async getAsinWorkerHealth(): Promise<AsinWorkerHealth> {
  return this.makeRequest<AsinWorkerHealth>('/asin/health', { method: 'GET' }, true);
}

async getAdminDashboardStats(start?: string, end?: string): Promise<AdminDashboardStats> {
  const params = new URLSearchParams();
  if (start) params.set('startDate', start);
  if (end) params.set('endDate', end);
  const qs = params.toString();
  return this.makeRequest<AdminDashboardStats>(
    `/admin/dashboard-stats${qs ? `?${qs}` : ''}`,
    { method: 'GET' },
    true
  );
}

// Tag Raporu — tarih aralığında tag başına sipariş sayısı
async getAdminTagReport(start?: string, end?: string): Promise<any> {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const qs = params.toString();
  return this.makeRequest<any>(`/admin/tag-report${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}

// Kaynak Raporu — kayıt kaynağına (reklam ?src=) göre sayılar
async getAdminSourceReport(start?: string, end?: string): Promise<any> {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const qs = params.toString();
  return this.makeRequest<any>(`/admin/source-report${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}

// ==================== STAFF PANELİ METODLARI ====================
async getStaffCustomers(params: { page?: number; pageSize?: number; search?: string; status?: string; active?: string; source?: string; dueToday?: boolean; sort?: string; dir?: string } = {}): Promise<StaffCustomerList> {
  const q = new URLSearchParams();
  if (params.page) q.set('page', String(params.page));
  if (params.pageSize) q.set('pageSize', String(params.pageSize));
  if (params.search) q.set('search', params.search);
  if (params.status) q.set('status', params.status);
  if (params.active) q.set('active', params.active);
  if (params.source) q.set('source', params.source);
  if (params.dueToday) q.set('dueToday', 'true');
  if (params.sort) q.set('sort', params.sort);
  if (params.dir) q.set('dir', params.dir);
  const qs = q.toString();
  return this.makeRequest<StaffCustomerList>(`/staff/customers${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}
/**
 * Müşteri listesini (ekrandaki filtrelerle, sayfalamasız) CSV olarak indirir — Excel açar.
 * Alanlar sunucuda sınırlı: kimlik + kaynak + aktiflik + CRM + sipariş sayısı (kazanç YOK).
 */
async downloadStaffCustomersCsv(params: { search?: string; status?: string; active?: string; source?: string; dueToday?: boolean } = {}): Promise<void> {
  const q = new URLSearchParams();
  if (params.search) q.set('search', params.search);
  if (params.status) q.set('status', params.status);
  if (params.active) q.set('active', params.active);
  if (params.source) q.set('source', params.source);
  if (params.dueToday) q.set('dueToday', 'true');
  const qs = q.toString();
  const token = localStorage.getItem('accessToken');
  const res = await fetch(`${API_BASE_URL}/staff/customers/export${qs ? `?${qs}` : ''}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(res.status === 401 || res.status === 403 ? 'Bu işlem için yetkiniz yok' : 'Liste indirilemedi');

  // Dosya adı sunucudan (Content-Disposition) — yoksa tarihli varsayılan
  const cd = res.headers.get('Content-Disposition') || '';
  const m = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const fileName = m ? decodeURIComponent(m[1]) : `musteri-listesi-${new Date().toISOString().slice(0, 10)}.csv`;

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
async updateStaffProfile(userId: string, body: { fullName?: string; phoneNumber?: string }): Promise<{ fullName: string; phoneNumber?: string | null }> {
  return this.makeRequest<{ fullName: string; phoneNumber?: string | null }>(`/staff/customers/${userId}/profile`, { method: 'PUT', body: JSON.stringify(body) }, true);
}
async setStaffCustomerActive(userId: string, isActive: boolean): Promise<{ isActive: boolean }> {
  return this.makeRequest<{ isActive: boolean }>(`/staff/customers/${userId}/active`, { method: 'PUT', body: JSON.stringify({ isActive }) }, true);
}
async getStaffCustomer(userId: string): Promise<StaffCustomerDetail> {
  return this.makeRequest<StaffCustomerDetail>(`/staff/customers/${userId}`, { method: 'GET' }, true);
}
async updateStaffCrm(userId: string, body: { status?: string | null; nextCallAtUtc?: string | null; nextCallTopic?: string | null; notes?: string | null }): Promise<any> {
  return this.makeRequest<any>(`/staff/customers/${userId}/crm`, { method: 'PUT', body: JSON.stringify(body) }, true);
}
async getStaffCalendar(from?: string, to?: string): Promise<{ from: string; to: string; count: number; items: StaffCalendarItem[] }> {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const qs = params.toString();
  return this.makeRequest<{ from: string; to: string; count: number; items: StaffCalendarItem[] }>(`/staff/calendar${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}
async addStaffContactLog(userId: string, body: { channel: string; note?: string }): Promise<StaffContactLogEntry> {
  return this.makeRequest<StaffContactLogEntry>(`/staff/customers/${userId}/contact-log`, { method: 'POST', body: JSON.stringify(body) }, true);
}
async deleteStaffContactLog(id: string): Promise<any> {
  return this.makeRequest<any>(`/staff/contact-log/${id}`, { method: 'DELETE' }, true);
}
async getStaffRemindersToday(): Promise<{ count: number; customers: StaffCustomer[] }> {
  return this.makeRequest<{ count: number; customers: StaffCustomer[] }>(`/staff/reminders/today`, { method: 'GET' }, true);
}
async getStaffStats(): Promise<StaffStats> {
  return this.makeRequest<StaffStats>(`/staff/stats`, { method: 'GET' }, true);
}
async getStaffSources(): Promise<{ sources: string[] }> {
  return this.makeRequest<{ sources: string[] }>(`/staff/sources`, { method: 'GET' }, true);
}
async getStaffSourceReport(start?: string, end?: string): Promise<{ total: number; sources: { source: string; count: number }[] }> {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  const qs = params.toString();
  return this.makeRequest<{ total: number; sources: { source: string; count: number }[] }>(`/staff/source-report${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}
// Admin: bir kullanıcıyı staff yap / staff'tan çıkar
async setUserStaffRole(userId: string, isStaff: boolean): Promise<any> {
  return this.makeRequest<any>(`/admin/users/${userId}/staff-role`, { method: 'PATCH', body: JSON.stringify({ isStaff }) }, true);
}

// ==================== API ANAHTARLARI (sunucu-sunucu entegrasyon) ====================
async getApiKeys(): Promise<{ ok: boolean; keys: ApiKeyRow[] }> {
  return this.makeRequest<{ ok: boolean; keys: ApiKeyRow[] }>('/admin/api-keys', { method: 'GET' }, true);
}

/** Anahtar SADECE bu yanıtta döner — bir daha görüntülenemez. */
async createApiKey(data: { name: string; userEmail: string; scopes?: string; rateLimitPerHour?: number; note?: string }): Promise<{ ok: boolean; id: string; name: string; userEmail: string; apiKey: string; warning: string }> {
  return this.makeRequest('/admin/api-keys', { method: 'POST', body: JSON.stringify(data) }, true);
}

/** Ad / saatlik limit / not günceller. Anahtarın kendisi değişmez. */
async updateApiKey(id: string, data: { name?: string; rateLimitPerHour?: number; note?: string }): Promise<{ ok: boolean; message: string }> {
  return this.makeRequest(`/admin/api-keys/${id}`, { method: 'PUT', body: JSON.stringify(data) }, true);
}

async revokeApiKey(id: string): Promise<{ ok: boolean; message: string }> {
  return this.makeRequest(`/admin/api-keys/${id}/revoke`, { method: 'POST' }, true);
}

async activateApiKey(id: string): Promise<{ ok: boolean; message: string }> {
  return this.makeRequest(`/admin/api-keys/${id}/activate`, { method: 'POST' }, true);
}

/** distinctIps: 1-3 = karşı tarafın sunucusu (istenen) · 50+ = anahtar dağıtılmış (alarm) */
async getApiKeyUsage(id: string, days = 7): Promise<ApiKeyUsageStats> {
  return this.makeRequest<ApiKeyUsageStats>(`/admin/api-keys/${id}/usage?days=${days}`, { method: 'GET' }, true);
}

// ==================== EKLENTİ LOG (TELEMETRİ) ====================
async getExtensionLogs(params: { email?: string; software?: string; level?: string; action?: string; flowId?: string; q?: string; from?: string; to?: string; page?: number; pageSize?: number } = {}): Promise<ExtensionLogList> {
  const p = new URLSearchParams();
  if (params.email) p.set('email', params.email);
  if (params.software) p.set('software', params.software);
  if (params.level) p.set('level', params.level);
  if (params.action) p.set('action', params.action);
  if (params.flowId) p.set('flowId', params.flowId);
  if (params.q) p.set('q', params.q);
  if (params.from) p.set('from', params.from);
  if (params.to) p.set('to', params.to);
  if (params.page) p.set('page', String(params.page));
  if (params.pageSize) p.set('pageSize', String(params.pageSize));
  const qs = p.toString();
  return this.makeRequest<ExtensionLogList>(`/admin/extension-logs${qs ? `?${qs}` : ''}`, { method: 'GET' }, true);
}
async getExtensionLogFlow(flowId: string): Promise<{ ok: boolean; flowId: string; count: number; items: ExtensionLogRow[] }> {
  return this.makeRequest<{ ok: boolean; flowId: string; count: number; items: ExtensionLogRow[] }>(`/admin/extension-logs/flow/${encodeURIComponent(flowId)}`, { method: 'GET' }, true);
}
async getExtensionLogFacets(days = 7): Promise<{ ok: boolean; emails: string[]; softwares: string[]; actions: string[] }> {
  return this.makeRequest<{ ok: boolean; emails: string[]; softwares: string[]; actions: string[] }>(`/admin/extension-logs/facets?days=${days}`, { method: 'GET' }, true);
}

// "Buradayım" sinyali — dashboard açıkken periyodik çağrılır (son görülme)
async sendHeartbeat(): Promise<void> {
  try { await this.makeRequest<any>('/me/heartbeat', { method: 'POST' }, true); } catch { /* sessiz */ }
}

// ==================== MUHASEBE (admin) ====================
async getAccountingPeriods(): Promise<{ periods: AccountingPeriodInfo[] }> {
  return this.makeRequest<{ periods: AccountingPeriodInfo[] }>('/admin/accounting/periods', { method: 'GET' }, true);
}
async getAccountingPeriod(year: number, month: number): Promise<AccountingReport> {
  return this.makeRequest<AccountingReport>(`/admin/accounting/${year}/${month}`, { method: 'GET' }, true);
}
async setAccountingRates(year: number, month: number, body: { userShareRatePercent?: number; workerRatePercent?: number }): Promise<any> {
  return this.makeRequest<any>(`/admin/accounting/${year}/${month}/rates`, { method: 'PUT', body: JSON.stringify(body) }, true);
}
// BringGo / autoorder: "sisteme kazandırdığı" manuel değer (null → sistem hesabına dön)
async setAccountingUserGross(year: number, month: number, userId: string, grossAmount: number | null): Promise<any> {
  return this.makeRequest<any>(`/admin/accounting/${year}/${month}/user-gross`, { method: 'PUT', body: JSON.stringify({ userId, grossAmount }) }, true);
}

async setAccountingUserRate(year: number, month: number, userId: string, ratePercent: number | null): Promise<any> {
  return this.makeRequest<any>(`/admin/accounting/${year}/${month}/user-rate`, { method: 'PUT', body: JSON.stringify({ userId, ratePercent }) }, true);
}
async addAccountingIncome(year: number, month: number, label: string, amount: number): Promise<AccountingLineItem> {
  return this.makeRequest<AccountingLineItem>(`/admin/accounting/${year}/${month}/income`, { method: 'POST', body: JSON.stringify({ label, amount }) }, true);
}
async deleteAccountingIncome(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/accounting/income/${id}`, { method: 'DELETE' }, true);
}
async addAccountingExpense(year: number, month: number, label: string, amount: number): Promise<AccountingLineItem> {
  return this.makeRequest<AccountingLineItem>(`/admin/accounting/${year}/${month}/expense`, { method: 'POST', body: JSON.stringify({ label, amount }) }, true);
}
async deleteAccountingExpense(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/accounting/expense/${id}`, { method: 'DELETE' }, true);
}
async closeAccountingPeriod(year: number, month: number): Promise<AccountingReport> {
  return this.makeRequest<AccountingReport>(`/admin/accounting/${year}/${month}/close`, { method: 'POST' }, true);
}
async reopenAccountingPeriod(year: number, month: number): Promise<AccountingReport> {
  return this.makeRequest<AccountingReport>(`/admin/accounting/${year}/${month}/reopen`, { method: 'POST' }, true);
}

// Eklenti sürüm kapısı (admin)
async getAdminExtensionConfig(): Promise<any> {
  return this.makeRequest<any>('/admin/extension-config', { method: 'GET' }, true);
}
async updateAdminExtensionConfig(body: { minVersion: string; latestVersion: string; updateUrl?: string | null; message?: string | null; autoSyncEnabled?: boolean; autoSyncIntervalDays?: number }): Promise<any> {
  return this.makeRequest<any>('/admin/extension-config', { method: 'PUT', body: JSON.stringify(body) }, true);
}

// Otomatik senkron — admin kullanıcı bazlı tetikle / iptal et
async requestUserSync(userId: string): Promise<any> {
  return this.makeRequest<any>(`/admin/users/${userId}/request-sync`, { method: 'POST' }, true);
}
async cancelUserSync(userId: string): Promise<any> {
  return this.makeRequest<any>(`/admin/users/${userId}/cancel-sync`, { method: 'POST' }, true);
}

// #3 — URL/Tag izleme (admin)
async getAdminUrlTrace(opts: { page?: number; pageSize?: number; onlyForeign?: boolean; userId?: string; from?: string; to?: string } = {}): Promise<UrlTraceListResponse> {
  const params = new URLSearchParams();
  params.set('page', String(opts.page ?? 1));
  params.set('pageSize', String(opts.pageSize ?? 50));
  if (opts.onlyForeign) params.set('onlyForeign', 'true');
  if (opts.userId) params.set('userId', opts.userId);
  if (opts.from) params.set('from', opts.from);
  if (opts.to) params.set('to', opts.to);
  return this.makeRequest<UrlTraceListResponse>(`/admin/url-trace?${params.toString()}`, { method: 'GET' }, true);
}
async getAdminUrlTraceSummary(): Promise<UrlTraceSummary> {
  return this.makeRequest<UrlTraceSummary>('/admin/url-trace/summary', { method: 'GET' }, true);
}
async deleteUrlTrace(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/url-trace/${id}`, { method: 'DELETE' }, true);
}
async bulkDeleteUrlTrace(body: { ids?: string[]; all?: boolean; onlyForeign?: boolean; userId?: string; from?: string; to?: string }): Promise<any> {
  return this.makeRequest<any>('/admin/url-trace/delete', { method: 'POST', body: JSON.stringify(body) }, true);
}

// Senkron turları (admin) — manuel + otomatik sipariş güncellemelerinin ne yaptığı
async getAdminSyncSummary(days = 30): Promise<AdminSyncSummary> {
  return this.makeRequest<AdminSyncSummary>(`/admin/sync/summary?days=${days}`, { method: 'GET' }, true);
}
async getAdminSyncRuns(opts: { page?: number; pageSize?: number; type?: string; outcome?: string; userId?: string; days?: number } = {}): Promise<AdminSyncRunsResponse> {
  const params = new URLSearchParams();
  params.set('page', String(opts.page ?? 1));
  params.set('pageSize', String(opts.pageSize ?? 50));
  params.set('days', String(opts.days ?? 30));
  if (opts.type) params.set('type', opts.type);
  if (opts.outcome) params.set('outcome', opts.outcome);
  if (opts.userId) params.set('userId', opts.userId);
  return this.makeRequest<AdminSyncRunsResponse>(`/admin/sync/runs?${params.toString()}`, { method: 'GET' }, true);
}
async getAdminSyncUsers(days = 30, limit = 100): Promise<AdminSyncUsersResponse> {
  return this.makeRequest<AdminSyncUsersResponse>(`/admin/sync/users?days=${days}&limit=${limit}`, { method: 'GET' }, true);
}
// "Bu sipariş neden doğrulanmadı" — admin başka kullanıcı için de sorabilir
async getVerificationExplain(orderId: string, userId?: string): Promise<VerificationExplain> {
  const params = new URLSearchParams({ orderId });
  if (userId) params.set('userId', userId);
  return this.makeRequest<VerificationExplain>(`/orders/verification-explain?${params.toString()}`, { method: 'GET' }, true);
}

// ===== Bildirimler (kullanıcı) =====
async getNotifications(): Promise<any> {
  return this.makeRequest<any>('/notifications', { method: 'GET' }, true);
}
async markNotificationsRead(notificationId?: string): Promise<any> {
  return this.makeRequest<any>('/notifications/mark-read', { method: 'POST', body: JSON.stringify({ notificationId: notificationId ?? null }) }, true);
}

// ===== Bildirimler (admin) =====
async createNotification(data: { title: string; message: string; priority: string; frequency: string; isForAll: boolean; userIds?: string[] }): Promise<any> {
  return this.makeRequest<any>('/admin/notifications', { method: 'POST', body: JSON.stringify(data) }, true);
}
async getAdminNotifications(): Promise<any[]> {
  return this.makeRequest<any[]>('/admin/notifications', { method: 'GET' }, true);
}
async getNotificationRecipients(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/notifications/${id}/recipients`, { method: 'GET' }, true);
}
async resendNotificationUnread(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/notifications/${id}/resend-unread`, { method: 'POST' }, true);
}
async toggleNotificationActive(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/notifications/${id}/toggle-active`, { method: 'POST' }, true);
}
async deleteNotification(id: string): Promise<any> {
  return this.makeRequest<any>(`/admin/notifications/${id}`, { method: 'DELETE' }, true);
}

// Users Management
async getAdminUsers(
  page: number = 1,
  pageSize: number = 20,
  search?: string,
  role?: string   // undefined = sadece müşteriler (User); 'Staff' | 'Admin' | 'all'
): Promise<AdminUsersListResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });

  if (search) {
    params.append('search', search);
  }
  if (role) {
    params.append('role', role);
  }

  return this.makeRequest<AdminUsersListResponse>(
    `/admin/users?${params}`,
    { method: 'GET' },
    true
  );
}

async getAdminUserDetails(userId: string): Promise<AdminUserDetails> {
  return this.makeRequest<AdminUserDetails>(
    `/admin/users/${userId}`,
    { method: 'GET' },
    true
  );
}

async toggleAdminUserActive(userId: string): Promise<ToggleUserActiveResponse> {
  return this.makeRequest<ToggleUserActiveResponse>(
    `/admin/users/${userId}/toggle-active`,
    { method: 'PATCH' },
    true
  );
}

async getAdminUserPaymentMethods(userId: string): Promise<PaymentMethod[]> {
  return this.makeRequest<PaymentMethod[]>(
    `/admin/users/${userId}/payment-methods`,
    { method: 'GET' },
    true
  );
}

// Orders Management
async getAdminOrders(
  page: number = 1,
  pageSize: number = 20,
  userEmail?: string,
  status?: string,
  verification?: string
): Promise<AdminOrdersListResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });

  // Kullanıcı filtresi: siteye üye olunan e-posta ("içerir"). GUID yerine.
  if (userEmail) {
    params.append('userEmail', userEmail);
  }

  if (status) {
    params.append('status', status);
  }

  // Doğrulama filtresi: 'verified' | 'unverified' (kural sunucuda)
  if (verification) {
    params.append('verification', verification);
  }

  return this.makeRequest<AdminOrdersListResponse>(
    `/admin/orders?${params}`,
    { method: 'GET' },
    true
  );
}

// Admin Authorization Check
isAdmin(): boolean {
  const role = localStorage.getItem('userRole');
  return role === 'Admin';
}
  // Orders endpoints
  async getOrdersByUserId(
    userId: string,
    page: number = 1,
    pageSize: number = 20,
    includeItems: boolean = false,
    status?: string,
    orderId?: string
  ): Promise<OrdersListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      includeItems: includeItems.toString()
    });

  // 🆕 Status filtresi
  if (status && status.trim() !== '') {
    params.append('status', status);
  }

  // 🆕 OrderId filtresi (arama)
  if (orderId && orderId.trim() !== '') {
    params.append('orderId', orderId.trim());
  }

  return this.makeRequest<OrdersListResponse>(
    `/orders/by-user/${userId}?${params}`, 
    { method: 'GET' }, 
    true
  );
}

  async getUserOrders(
    page: number = 1,
    pageSize: number = 20,
    includeItems: boolean = false
  ): Promise<OrdersListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      includeItems: includeItems.toString()
    });

    return this.makeRequest<OrdersListResponse>(
      `/orders?${params}`, 
      { method: 'GET' }, 
      true
    );
  }

  async getOrdersByCurrentUser(
    page: number = 1,
    pageSize: number = 20,
    includeItems: boolean = true
  ): Promise<OrdersListResponse> {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      throw new Error('User ID not found');
    }

    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      includeItems: includeItems.toString()
    });

    return this.makeRequest<OrdersListResponse>(
      `/orders/by-user/${userId}?${params}`, 
      { method: 'GET' }, 
      true
    );
  }

  async getOrderDetails(orderId: string): Promise<OrderDetailResponse> {
    return this.makeRequest<OrderDetailResponse>(
      `/orders/${orderId}/items`, 
      { method: 'GET' }, 
      true
    );
  }

async getDashboardStats(startDate?: string, endDate?: string, format: string = 'events'): Promise<DashboardStatsResponse> {
  let url = `/orders/dashboard-stats`;
  
  const params = new URLSearchParams();
  
  if (startDate && endDate) {
    params.append('startDate', startDate);
    params.append('endDate', endDate);
  }
  
  // format parametresini her zaman ekle
  params.append('format', format);
  
  url += `?${params}`;
  
  return this.makeRequest<DashboardStatsResponse>(
    url, 
    { method: 'GET' }, 
    true
  );
}


  // ========== PROFILE MANAGEMENT ENDPOINTS ==========
  
  async getUserProfile(): Promise<UserProfile> {
    return this.makeRequest<UserProfile>(
      '/users/profile',
      { method: 'GET' },
      true
    );
  }

  async updateUserProfile(data: UpdateProfileRequest): Promise<void> {
    return this.makeRequest<void>(
      '/users/profile',
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
      true
    );
  }

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    return this.makeRequest<void>(
      '/users/change-password',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  }

  async getUserStats(): Promise<UserProfile['stats']> {
    return this.makeRequest<UserProfile['stats']>(
      '/users/stats',
      { method: 'GET' },
      true
    );
  }

  // ========== PAYMENT METHODS ENDPOINTS (UPDATED) ==========
  
  async getPaymentMethods(): Promise<PaymentMethod[]> {
    return this.makeRequest<PaymentMethod[]>(
      '/payment-methods',
      { method: 'GET' },
      true
    );
  }

  async getPaymentMethod(id: string): Promise<PaymentMethod> {
    return this.makeRequest<PaymentMethod>(
      `/payment-methods/${id}`,
      { method: 'GET' },
      true
    );
  }

  async addPaymentMethod(data: AddPaymentMethodRequest): Promise<PaymentMethod> {
    return this.makeRequest<PaymentMethod>(
      '/payment-methods',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  }

  async updatePaymentMethod(id: string, data: UpdatePaymentMethodRequest): Promise<PaymentMethod> {
    return this.makeRequest<PaymentMethod>(
      `/payment-methods/${id}`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
      true
    );
  }

  async deletePaymentMethod(id: string): Promise<void> {
    return this.makeRequest<void>(
      `/payment-methods/${id}`,
      { method: 'DELETE' },
      true
    );
  }

  async setPrimaryPaymentMethod(id: string): Promise<void> {
    return this.makeRequest<void>(
      `/payment-methods/${id}/set-primary`,
      { method: 'POST' },
      true
    );
  }
  // ==================== ORGANIZATION ENDPOINTS (YENİ) ====================
  async getOrganizations(): Promise<Organization[]> {
    return this.makeRequest<Organization[]>('/organizations', {
      method: 'GET',
    }, true);
  }

  async getOrganizationById(id: string): Promise<Organization> {
    return this.makeRequest<Organization>(`/organizations/${id}`, {
      method: 'GET',
    }, true);
  }

  async createOrganization(data: CreateOrganizationRequest): Promise<Organization> {
    return this.makeRequest<Organization>('/organizations', {
      method: 'POST',
      body: JSON.stringify(data),
    }, true);
  }

  async updateOrganization(id: string, data: UpdateOrganizationRequest): Promise<Organization> {
    return this.makeRequest<Organization>(`/organizations/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }, true);
  }

  async deleteOrganization(id: string): Promise<void> {
    return this.makeRequest<void>(`/organizations/${id}`, {
      method: 'DELETE',
    }, true);
  }

  async validateOrganizationCode(code: string): Promise<OrganizationValidation> {
    return this.makeRequest<OrganizationValidation>(`/organizations/validate/${code}`, {
      method: 'GET',
    }, false); // Public endpoint - auth gerekmez
  }

  async generateOrganizationCode(data: GenerateCodeRequest): Promise<GenerateCodeResponse> {
    return this.makeRequest<GenerateCodeResponse>('/organizations/generate-code', {
      method: 'POST',
      body: JSON.stringify(data),
    }, true);
  }
  
  async getOrganizationUsers(organizationId: string): Promise<OrganizationUser[]> {
  return this.makeRequest<OrganizationUser[]>(
    `/organizations/${organizationId}/users`,
    { method: 'GET' },
    true
  );
}

// ========== EARNINGS ENDPOINTS ==========

  async getUserEarnings(): Promise<any> {
    return this.makeRequest<any>('/earnings', { method: 'GET' }, true);
  }

  async getPeriodDetail(year: number, month: number): Promise<any> {
    return this.makeRequest<any>(`/earnings/${year}/${month}`, { method: 'GET' }, true);
  }

  async getAdminPendingPayments(): Promise<any> {
    return this.makeRequest<any>('/admin/earnings/pending', { method: 'GET' }, true);
  }

  async getAdminUserPeriods(userId: string): Promise<any> {
    return this.makeRequest<any>(`/admin/earnings/user/${userId}`, { method: 'GET' }, true);
  }

  async approvePayment(
    userId: string,
    year: number,
    month: number,
    request: { transactionReference?: string; paymentNote?: string; closeAtZero?: boolean }
  ): Promise<any> {
    return this.makeRequest<any>(
      `/admin/earnings/approve/${userId}/${year}/${month}`,
      { method: 'POST', body: JSON.stringify(request) },
      true
    );
  }

  async bulkApprovePayments(request: any): Promise<any> {
    return this.makeRequest<any>(
      '/admin/earnings/bulk-approve',
      { method: 'POST', body: JSON.stringify(request) },
      true
    );
  }

  async getPaymentHistory(page: number = 1, pageSize: number = 20): Promise<any> {
    return this.makeRequest<any>(
      `/admin/earnings/history?page=${page}&pageSize=${pageSize}`,
      { method: 'GET' },
      true
    );
  }

  // ---- DEVİR (carry-over): asgari ödeme tutarının altında kalan dönemler ----

  async carryOverEarningPeriod(userId: string, year: number, month: number): Promise<any> {
    return this.makeRequest<any>(
      `/admin/earnings/carry-over/${userId}/${year}/${month}`,
      { method: 'POST' },
      true
    );
  }

  async undoCarryOverEarningPeriod(userId: string, year: number, month: number): Promise<any> {
    return this.makeRequest<any>(
      `/admin/earnings/carry-over/undo/${userId}/${year}/${month}`,
      { method: 'POST' },
      true
    );
  }

  async getMinPayout(): Promise<any> {
    return this.makeRequest<any>('/admin/earnings/min-payout', { method: 'GET' }, true);
  }

  async setMinPayout(minPayoutAmount: number): Promise<any> {
    return this.makeRequest<any>(
      '/admin/earnings/min-payout',
      { method: 'PUT', body: JSON.stringify({ minPayoutAmount }) },
      true
    );
  }

  async carryOverAffiliatePeriod(userId: string, year: number, month: number): Promise<any> {
    return this.makeRequest<any>(
      '/admin/affiliate/carry-over',
      { method: 'POST', body: JSON.stringify({ userId, year, month }) },
      true
    );
  }

  async undoCarryOverAffiliatePeriod(userId: string, year: number, month: number): Promise<any> {
    return this.makeRequest<any>(
      '/admin/affiliate/carry-over/undo',
      { method: 'POST', body: JSON.stringify({ userId, year, month }) },
      true
    );
  }

// ========== PLUGIN SETTINGS ENDPOINTS ==========

async getPluginSettings(): Promise<PluginSettings> {
  return this.makeRequest<PluginSettings>(
    '/plugin/settings',
    { method: 'GET' },
    true
  );
}

async savePluginSettings(data: SavePluginSettingsRequest): Promise<PluginSettings> {
  return this.makeRequest<PluginSettings>(
    '/plugin/settings',
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    true
  );
}

// ==================== GİZLİLİK MODU ====================
/** Gizlilik modunu kaydet. PIN tanımlıysa currentPin zorunludur. */
async savePrivacySettings(data: SavePrivacyRequest): Promise<PluginSettings> {
  return this.makeRequest<PluginSettings>(
    '/plugin/settings/privacy',
    { method: 'POST', body: JSON.stringify(data) },
    true
  );
}

/** PIN doğrulama — doğrulama sunucuda yapılır, hash istemciye hiç gelmez. */
async verifyPrivacyPin(pin: string): Promise<{ valid: boolean; hasPin: boolean }> {
  return this.makeRequest<{ valid: boolean; hasPin: boolean }>(
    '/plugin/settings/privacy/verify',
    { method: 'POST', body: JSON.stringify({ pin }) },
    true
  );
}

async updatePluginSettings(data: SavePluginSettingsRequest): Promise<PluginSettings> {
  return this.makeRequest<PluginSettings>(
    '/plugin/settings',
    {
      method: 'PUT',
      body: JSON.stringify(data),
    },
    true
  );
}

// ========== END PLUGIN SETTINGS ENDPOINTS ==========
private async makeRequest<T>(
    endpoint: string, 
    options: RequestInit = {},
    includeAuth: boolean = false
  ): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;
    const headers = this.getHeaders(includeAuth);

    const response = await fetch(url, {
      ...options,
      headers: {
        ...headers,
        ...options.headers,
      },
    });

    if (!response.ok) {
      // ✅ Önce response body'sini text olarak oku (JSON da olsa text de olsa çalışır)
      const rawBody = await response.text();
      let errorMessage = '';

      // JSON parse etmeyi dene
try {
        const errorData = JSON.parse(rawBody);
        
        // ASP.NET Core validation errors: { errors: { Field: ["mesaj"] } }
        if (errorData.errors && typeof errorData.errors === 'object') {
          const messages: string[] = [];
          for (const field in errorData.errors) {
            const fieldErrors = errorData.errors[field];
            if (Array.isArray(fieldErrors)) {
              // Field adını Türkçeleştir
              const fieldNameMap: Record<string, string> = {
                'Email': 'E-posta',
                'PhoneNumber': 'Telefon numarası',
                'Password': 'Şifre',
                'FullName': 'Ad soyad',
                'OrganizationCode': 'Organizasyon kodu',
              };
              const friendlyField = fieldNameMap[field] || field;
              
              fieldErrors.forEach((err: string) => {
                // İngilizce mesajları Türkçeleştir
                let friendlyMsg = err
                  .replace(/The (\w+) field is required\./i, `${friendlyField} alanı zorunludur.`)
                  .replace(/The (\w+) field is not a valid phone number\./i, 'Geçerli bir telefon numarası girin.')
                  .replace(/The (\w+) field is not a valid e-mail address\./i, 'Geçerli bir e-posta adresi girin.')
                  .replace(/The field (\w+) must be a string with a minimum length of (\d+)/i, `$1 en az $2 karakter olmalıdır.`);
                messages.push(friendlyMsg);
              });
            }
          }
          if (messages.length > 0) {
            errorMessage = messages.join(' ');
          }
        }
        
        if (!errorMessage) {
          errorMessage = errorData.title || errorData.message || errorData.error || '';
        }
        
        if (!errorMessage && typeof errorData === 'string') {
          errorMessage = errorData;
        }
      } catch {
        errorMessage = rawBody.trim();
      }

      // Hâlâ boşsa, status code'a göre kullanıcı dostu mesaj ver
      if (!errorMessage) {
        switch (response.status) {
          case 400:
            errorMessage = 'Geçersiz istek. Bilgilerinizi kontrol edin.';
            break;
          case 401:
            errorMessage = 'E-posta veya şifre hatalı.';
            break;
          case 403:
            errorMessage = 'Bu işlem için yetkiniz yok.';
            break;
          case 404:
            errorMessage = 'Aradığınız kayıt bulunamadı.';
            break;
          case 409:
            errorMessage = 'Bu kayıt zaten mevcut.';
            break;
          case 500:
            errorMessage = 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.';
            break;
          case 503:
            errorMessage = 'Servis geçici olarak kullanılamıyor.';
            break;
          default:
            errorMessage = `Bir hata oluştu (${response.status})`;
        }
      }

      throw new Error(errorMessage);
    }

    // 204 No Content gibi boş response'lar için
    const text = await response.text();
    return text ? JSON.parse(text) : ({} as T);
  }

  // Auth endpoints
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }

  async register(userData: RegisterRequest): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }

  // ===== Bağlı Hesaplar (hesap geçişi) =====
  async linkAccount(email: string, password: string): Promise<any> {
    return this.makeRequest<any>('/auth/link-account', { method: 'POST', body: JSON.stringify({ email, password }) }, true);
  }
  async getLinkedAccounts(): Promise<any[]> {
    return this.makeRequest<any[]>('/auth/linked-accounts', { method: 'GET' }, true);
  }
  async switchAccount(targetUserId: string): Promise<AuthResponse> {
    return this.makeRequest<AuthResponse>('/auth/switch-account', { method: 'POST', body: JSON.stringify({ targetUserId }) }, true);
  }
  async unlinkAccount(targetUserId: string): Promise<any> {
    return this.makeRequest<any>('/auth/unlink-account', { method: 'POST', body: JSON.stringify({ targetUserId }) }, true);
  }

  // User endpoints
  async getCurrentUser(): Promise<User> {
    return this.makeRequest<User>('/users/me', {
      method: 'GET',
    }, true);
  }

    // ==================== SÖZLEŞME METOTLARI (YENİ) ====================

  async getTermsStatus(): Promise<{ hasAcceptedTerms: boolean; currentVersion: string; acceptedVersion: string | null }> {
    return this.makeRequest('/auth/terms-status', { method: 'GET' }, true);
  }

  async acceptTerms(): Promise<{ message: string; hasAcceptedTerms: boolean; termsVersion: string; acceptedAt: string }> {
    return this.makeRequest('/auth/accept-terms', { method: 'POST' }, true);
  }

  async declineTerms(): Promise<{ message: string; isActive: boolean }> {
    return this.makeRequest('/auth/decline-terms', { method: 'POST' }, true);
  }

  // ==================== AFFILIATE TAG METHODS ====================

async getAffiliateTags(): Promise<AffiliateTagListResponse> {
  return this.makeRequest<AffiliateTagListResponse>(
    '/admin/affiliate-tags',
    { method: 'GET' },
    true
  );
}

async getAffiliateTag(tagId: string): Promise<AffiliateTag> {
  return this.makeRequest<AffiliateTag>(
    `/admin/affiliate-tags/${tagId}`,
    { method: 'GET' },
    true
  );
}

async createAffiliateTag(data: CreateAffiliateTagRequest): Promise<AffiliateTag> {
  return this.makeRequest<AffiliateTag>(
    '/admin/affiliate-tags',
    {
      method: 'POST',
      body: JSON.stringify(data)
    },
    true
  );
}

async updateAffiliateTag(tagId: string, data: UpdateAffiliateTagRequest): Promise<AffiliateTag> {
  return this.makeRequest<AffiliateTag>(
    `/admin/affiliate-tags/${tagId}`,
    {
      method: 'PUT',
      body: JSON.stringify(data)
    },
    true
  );
}

async deleteAffiliateTag(tagId: string): Promise<{ message: string }> {
  return this.makeRequest<{ message: string }>(
    `/admin/affiliate-tags/${tagId}`,
    { method: 'DELETE' },
    true
  );
}

async getAffiliateTagsDropdown(): Promise<AffiliateTagDropdown[]> {
  return this.makeRequest<AffiliateTagDropdown[]>(
    '/admin/affiliate-tags/dropdown',
    { method: 'GET' },
    true
  );
}

async getTagUsers(tagId: string): Promise<TagUsersResponse> {
  return this.makeRequest<TagUsersResponse>(
    `/admin/affiliate-tags/${tagId}/users`,  // /admin/ eklendi
    { method: 'GET' },
    true
  );
}

async bulkAssignTag(data: BulkAssignTagRequest): Promise<BulkAssignTagResponse> {
  return this.makeRequest<BulkAssignTagResponse>(
    '/admin/users/bulk-assign-tag',
    {
      method: 'POST',
      body: JSON.stringify(data)
    },
    true
  );
}

  // Token management
  saveAuthData(authResponse: AuthResponse): void {
    localStorage.setItem('accessToken', authResponse.accessToken);
    localStorage.setItem('userEmail', authResponse.email);
    localStorage.setItem('userFullName', authResponse.fullName);
    localStorage.setItem('userRole', authResponse.role);
    localStorage.setItem('userId', authResponse.userId);
    localStorage.setItem('tokenExpiry', authResponse.expiresAtUtc);
    // Sözleşme durumunu kaydet ← YENİ
    localStorage.setItem('hasAcceptedTerms', String(authResponse.hasAcceptedTerms));
    // YENİ: Organizasyon bilgilerini kaydet
    if (authResponse.organizationName) {
      localStorage.setItem('organizationName', authResponse.organizationName);
    } else {
      localStorage.removeItem('organizationName');
    }
    
    if (authResponse.organizationCode) {
      localStorage.setItem('organizationCode', authResponse.organizationCode);
    } else {
      localStorage.removeItem('organizationCode');
    }
  }

  clearAuthData(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    localStorage.removeItem('tokenExpiry');
    localStorage.removeItem('organizationName'); // YENİ
    localStorage.removeItem('organizationCode'); // YENİ
    localStorage.removeItem('hasAcceptedTerms');  // ← YENİ
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('accessToken');
    const expiry = localStorage.getItem('tokenExpiry');
    
    if (!token || !expiry) {
      return false;
    }

    const expiryDate = new Date(expiry);
    return expiryDate > new Date();
  }

  getStoredUserData() {
    return {
      email: localStorage.getItem('userEmail'),
      fullName: localStorage.getItem('userFullName'),
      role: localStorage.getItem('userRole'),
      userId: localStorage.getItem('userId'),
      organizationName: localStorage.getItem('organizationName'), // YENİ
      organizationCode: localStorage.getItem('organizationCode'), // YENİ
      hasAcceptedTerms: localStorage.getItem('hasAcceptedTerms') === 'true',  // ← YENİ
    };
  }
}

export const apiService = new ApiService();